import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';


// Home component
import HomeScreen from './screens/HomeScreen/HomeScreen';

const AppRoutes = () => {
  return (
    <Routes>
      
      {/* Home page route - made public */}
      <Route path="/" element={<HomeScreen />} />
      
      {/* Catch all route - redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes; 